<script setup lang="ts">
import { VueQueryDevtools } from '@tanstack/vue-query-devtools';
/**
 * The Base Layout
 * --------------------------------
 * Used in ALL layouts. Wraps all normal pages
 * - adds basics like error toasts, confirm dialogs, loading overlays etc
 * - adds SEO head
 */

const { bodyClasses = '' } = defineProps<{
    bodyClasses?: string;
}>();

const head = useLocaleHead({ seo: true });
const isSubFlow = inject('isSubFlow', false);

useHead({
    bodyAttrs: {
        tagDuplicateStrategy: 'replace',
        class: [
            'bg-background-1',
            'typo-copy',
            'text-brand-b',
        ]
            .concat(bodyClasses)
            .join(' '),
    },
    titleTemplate: title => title
        ? `${title} - Top of Travel | jungfrau.ch`
        : 'Top of Travel | jungfrau.ch',
});
</script>

<template>
    <div>
        <Html :lang="head.htmlAttrs?.lang">
            <Body>
                <div
                    class="
                    grid
                    min-h-dvh
                    grid-rows-[min-content_auto]
                "
                >
                    <div class="sticky top-0 z-31 print:hidden" :class="isSubFlow ? 'bg-background-2' : ''">
                        <TheToasts />
                    </div>

                    <div>
                        <slot />
                    </div>
                </div>
                <TheLoadingOverlay />
                <TheConfirmDialog />
                <ClientOnly>
                    <TheDevHelper v-if="useRuntimeConfig().public.enableDevHelpers" />
                    <VueQueryDevtools
                        position="right"
                        button-position="bottom-left"
                        class="print:hidden"
                    />
                </ClientOnly>
            </Body>
        </Html>
    </div>
</template>
